import React, { useEffect, useState } from 'react';
import QuestionResponse from 'models/QuestionResponse';
import { Grid } from '@mui/material';
import ImageChoice from '../../ImageChoice';
import MultipleChoiceOption from 'models/MultipleChoiceOption';

type VisualMultipleChoiceOptionsProps = {
  check: boolean;
  choices: MultipleChoiceOption[];
  response: QuestionResponse;
  onUpdateResponse: (
    responseChoice: string,
    correct: boolean,
    feedback?: string,
    isAttempt?: boolean,
  ) => void;
};

const VisualMultipleChoiceOptions: React.FC<
  VisualMultipleChoiceOptionsProps
> = ({ check, choices, response, onUpdateResponse }) => {
  const [imageMap, setImageMap] = useState<Record<string, string>>({});

  useEffect(() => {
    // Load all images asynchronously
    const loadImages = async () => {
      const newImageMap: Record<string, string> = {};
      for (const choice of choices) {
        try {
          const imgSrc = await choice.getImageSrc();
          if (imgSrc) {
            newImageMap[choice.id] = imgSrc;
          }
        } catch (error) {
          console.error(`Failed to load image for choice ${choice.id}:`, error);
        }
      }
      setImageMap(newImageMap);
    };

    loadImages();
  }, [choices]);

  return (
    <>
      {choices?.length && (
        <Grid container>
          {choices.map((choice) => (
            <Grid key={`image-choice-${choice.id}`} item>
              <ImageChoice
                key={`choice-${choice.id}`}
                id={`choice-${choice.id}`}
                selected={
                  check
                    ? choice.correct
                    : Number(response.choice) === Number(choice.id)
                }
                onClick={() =>
                  response.num_attempts === 0 &&
                  !response.completed &&
                  onUpdateResponse(
                    choice.id,
                    choice.correct,
                    response.feedback,
                    false,
                  )
                }
                onDoubleClick={() =>
                  response.num_attempts === 0 &&
                  !response.completed &&
                  onUpdateResponse(
                    choice.id,
                    choice.correct,
                    response.feedback,
                    false,
                  )
                }
                highlight={choice.correct && check}
                incorrect={
                  !choice.correct &&
                  Number(response.choice) === Number(choice.id) &&
                  check
                }
              >
                {imageMap[choice.id] ? (
                  <img src={imageMap[choice.id]} alt="" />
                ) : (
                  <div className="image-loading">Loading...</div>
                )}
              </ImageChoice>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default VisualMultipleChoiceOptions;
